import { render, staticRenderFns } from "./TrademarkSearchSuccessRateList.vue?vue&type=template&id=5b1cb1d0&"
import script from "./TrademarkSearchSuccessRateList.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchSuccessRateList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchSuccessRateList.vue?vue&type=style&index=0&id=5b1cb1d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports